import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// Import translations
import en from './en.json'
import gr from './gr.json'

export const LANGUAGE_STORAGE_KEY = 'maluLanguage'

const supportedLanguages = ['en', 'gr'] as const
type SupportedLanguage = (typeof supportedLanguages)[number]

const getStoredLanguage = (): SupportedLanguage => {
  if (typeof window === 'undefined') {
    return 'en'
  }

  const storedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY)
  return supportedLanguages.includes(storedLanguage as SupportedLanguage) ? (storedLanguage as SupportedLanguage) : 'en'
}

// Initialize i18n
i18n
  .use(initReactI18next) // Passes i18n instance to react-i18next
  .init({
    resources: {
      en: { translation: en },
      gr: { translation: gr },
    },
    lng: getStoredLanguage(), // Default language
    fallbackLng: 'en', // Fallback language if translation is not found
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
  })

export default i18n
